import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { BankDetailsClientEditFormComponent } from './bank-details-client-form/bank-details-client-edit-form.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { BankDetailsService } from '../../../core/services/bank/bank-details/bank-details.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { MatDivider } from '@angular/material/divider'
import { responseDefaultForm } from '../../../shared/utils/utils'

@Component({
  selector: 'bank-details-client-edit',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    BankDetailsClientEditFormComponent,
    MatProgressBar,
    FormClientSearchComponent,
    MatDivider,
  ],
  templateUrl: './bank-details-client-edit.component.html',
  styleUrl: './bank-details-client-edit.component.scss',
  providers: [BankDetailsService],
  standalone: true,
})
export class BankDetailsClientEditComponent implements OnInit, AfterViewInit {
  constructor(
    private bankDetailsService: BankDetailsService,
    private snackbar: SnackbarCustomService,
  ) {}

  item: any = {}
  loading: boolean = true

  @Output() response: EventEmitter<any> = new EventEmitter()
  @Input() idPerson: number = 0
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'bank',
      key: 'nomeBanco',
      description: 'Banco',
    },
    {
      keyColumn: 'bank_branch',
      key: 'agencia',
      description: 'Agência',
    },
    {
      keyColumn: 'account',
      key: 'conta',
      description: 'Conta',
    },
    {
      keyColumn: 'pix',
      key: 'pix',
      description: 'Pix',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]

  page: number = 1
  rows: number = 10
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = [
    'bank',
    'bank_branch',
    'account',
    'pix',
    'action',
  ]

  inputSearchBankDetail: any = { type: '', search: '' }
  listSearch: any = [
    {
      id: 'bancoId',
      description: 'Banco',
      type: 'number',
      visible: false,
    },
    { id: 'conta', description: 'Conta', type: 'string', visible: true },
    { id: 'agencia', description: 'Agência', type: 'string', visible: true },
  ]

  searchForm: any = { search: false, model: {} }

  ngOnInit(): void {
    this.getBankDetailsByPerson()
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    // if (this.table) {
    //   this.table.renderRows()
    // }
  }

  pageChanged($event: any) {
    this.page = $event.pageIndex + 1
    // this.rows = $event.pageSize
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchBankDetails()
    } else {
      this.getBankDetailsByPerson()
    }
  }

  getBankDetailsByPerson() {
    this.loading = true
    this.bankDetailsService
      .listPagedBankDetailsByPerson(this.idPerson, this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchBankDetails() {
    this.loading = true
    this.bankDetailsService
      .searchPagedBankDetails(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push({
          ...item,
          ativo: item.statusBanco.toUpperCase() == 'S' ? 'Ativo' : 'Inativo',
        })
      }
    }
    this.tableSource = new MatTableDataSource<any>(list)
    this.refreshTable()
  }

  responseForm(response: any): void {
    if (response.refresh) {
      this.uploadList()
    }
    if (response.clear) {
      this.clearItem()
    }
  }

  updateItem(element: any) {
    this.item = { edit: true, data: element }
  }

  deleteItem(element: any) {
    this.clearItem()
    this.bankDetailsService.deleteBankDetails({ id: element.id }).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
        this.snackbar.success(err.message)
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  clearItem() {
    this.item = {}
  }

  createModel(element: any) {
    let model: any = { pessoaId: this.idPerson }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }
}
